/**
 * localStorage key for an invitation token captured while the visitor was
 * signed out. Registration includes it in the register payload, and the
 * post-login redirect returns the user to the invitation page.
 */
export const PENDING_INVITE_TOKEN_KEY = "pendingInviteToken";
